import React from "react";

import styles from './HeroSection.module.scss';
import SectionWrapper from "components/elements/SectionWrapper";

// Alle Properties dynamisch aus props übernehmenw
const HeroSection = (props) => {

	return (
			<SectionWrapper 
				className={`${styles.HeroSection}`} 
				fluid={false} 
				titleClasses="display-4"
				{...props}
				btn_variant="light"
				btn_size="lg"
			/>
	);
};

export default HeroSection;